import classNames from 'classnames'
import { observer } from 'mobx-react-lite'
import { useState } from 'react'
import {
  Box,
  Button,
  Divider,
  Icon,
  IconButton,
  InputCheckbox,
  TextareaWithLabel,
  TextFieldWithLabel,
  Typography,
} from 'shared/ui'
import { useWidgetChatContext } from 'pages/settings/pages/widgetChat/context/widgetChatContext'

import styles from './styles.module.scss'

export const ContentRight = observer(() => {
  const { customizeBlockStore, conversationsBlockStore, isChatVisible, setIsChatVisible } =
    useWidgetChatContext()
  const { sendFromStore } = conversationsBlockStore
  const displayNumber =
    sendFromStore.number?.formatted_number ??
    (sendFromStore.inbox && 'number' in sendFromStore.inbox && sendFromStore.inbox.number
      ? sendFromStore.inbox.number.formatted_number
      : '')
  const headerText = customizeBlockStore.header.trim() || 'Header'
  const themeColor = customizeBlockStore.color
  const isLeftPosition = customizeBlockStore.position === 'left'
  const welcomeMessage = customizeBlockStore.message.trim() || 'Welcome message'
  const complianceLabel = customizeBlockStore.opt_in_text.trim() || 'Compliance'
  const buttonText = customizeBlockStore.button.trim() || 'Button'

  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [phone, setPhone] = useState('')
  const [message, setMessage] = useState('')
  const [agreed, setAgreed] = useState(false)

  return (
    <Box className={styles.rightBlock}>
      <div className={classNames(styles.frame, isLeftPosition && styles.frameLeft)}>
        {isChatVisible && (
          <div
            className={classNames(styles.chatContainer, isLeftPosition && styles.chatContainerLeft)}
          >
            <div className={styles.chatHeader} style={{ backgroundColor: themeColor }}>
              <Typography
                ariaLabel='WidgetChat_right_placeholder'
                variant='body-lg-medium'
                color='var(--white-100)'
              >
                {headerText}
              </Typography>
              <IconButton
                ariaLabel='WidgetChat_right_close'
                variant='icon'
                transparentBackground
                iconProps={{ color: 'var(--white-100)' }}
                icon='close'
                className={styles.chatHeaderCloseButton}
                onClick={() => setIsChatVisible(false)}
              />
            </div>
            <div className={styles.chatContent}>
              <TextFieldWithLabel
                textFieldProps={{
                  size: 'medium',
                  className: styles.chatTextField,
                  value: name,
                  onChange: setName,
                  InputProps: { placeholder: 'Name *' },
                }}
              />
              <TextFieldWithLabel
                textFieldProps={{
                  size: 'medium',
                  className: styles.chatTextField,
                  value: email,
                  onChange: setEmail,
                  InputProps: { placeholder: 'Email' },
                }}
              />
              <TextFieldWithLabel
                textFieldProps={{
                  size: 'medium',
                  className: styles.chatTextField,
                  value: phone,
                  onChange: setPhone,
                  InputProps: { placeholder: 'Phone *' },
                }}
              />
              <TextareaWithLabel
                labelProps={{ label: undefined }}
                placeholder='Message *'
                value={message}
                onChange={setMessage}
                classNameTextarea={styles.chatTextarea}
              />
              <InputCheckbox
                className={styles.checkboxTopAlign}
                checked={agreed}
                onChecked={() => setAgreed((prev) => !prev)}
                label={complianceLabel}
                variant='body-sm-regular'
                color='var(--content-primary-secondary)'
              />
              <Button
                text={buttonText}
                size='extraLarge'
                className={styles.sendButton}
                textClassname={styles.sendButtonText}
                style={{ backgroundColor: themeColor }}
              />
              {displayNumber ? (
                <Typography
                  ariaLabel='WidgetChat_text_us'
                  variant='body-rg-regular'
                  color='var(--content-primary-primary)'
                  className={styles.textUs}
                >
                  Text us {displayNumber}
                </Typography>
              ) : null}
            </div>
            <Divider />
            <div className={styles.footer}>
              <Icon icon='logoOld' color='#1D95F2' fontSize={14} />
              <Typography
                ariaLabel='WidgetChat_try_texting'
                variant='body-sm-regular'
                className={styles.footerText}
              >
                Try texting with Salesmsg
              </Typography>
            </div>
          </div>
        )}
        {!isChatVisible && (
          <div
            className={classNames(styles.chatCollapsed, isLeftPosition && styles.chatCollapsedLeft)}
            data-testid='chat-collapsed'
          >
            <div className={styles.chatCollapsedCloseButton}>
              <Icon
                ariaLabel='WidgetChat_close_chat'
                icon='close'
                color='var(--content-primary-primary)'
                fontSize={16}
              />
            </div>
            <Typography
              ariaLabel='WidgetChat_welcome_message'
              variant='body-md-regular'
              color='var(--content-primary-primary)'
              className={styles.welcomeMessage}
            >
              {welcomeMessage}
            </Typography>
          </div>
        )}
        <button
          type='button'
          className={classNames(styles.collapseButton, isLeftPosition && styles.collapseButtonLeft)}
          style={{ backgroundColor: themeColor }}
          onClick={() => setIsChatVisible(!isChatVisible)}
          aria-label={isChatVisible ? 'Collapse chat' : 'Show chat'}
        >
          <Icon icon={isChatVisible ? 'close' : 'logoOld'} color='var(--white-100)' fontSize={24} />
        </button>
      </div>
    </Box>
  )
})
